export const reward = {
  loyaltyReward: "Loyalty Reward",
  reward: "Reward",
  search: "Search",
  advanceFilter: "Advance Filter",
  createNewReward: "Create new Reward",
  editReward: "Edit Reward",
  name: "name",
  selectCategory: "SELECT CATEGORY",
  other: "OTHER",
  selectType: "SELECT TYPE",
  normal: "NORMAL",
  cash: "CASH",
  close: "close",
  filter: "filter",
  point: "Point",
  quantity: "Quantity",
  type: "Type",
  image: "Image",
  previewImage: "Preview Image",
  active: "Active",
  create: "create",
  edit: "Edit",
  category: "Category",
  dateCreated: "Date Created",
  status: "Status",
  clickToUpload: "Click To Upload",
  imageUrl: "Image URL",
  upload: "Upload",
  fortuneWheel: "FORTUNE_WHEEL",
  description:"description"
};
